/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_accordeon = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

		/*
		Header: Buttons Map en Menu
		Header: Buttons Map en Menu
		Header: Buttons Map en Menu
		Header: Buttons Map en Menu
		*/
		$(document).on('click','.js-accordeon-item',function() {
			
			var _this_id = $(this).data('id');

			specific_accordeon.openAndClose(_this_id);

		});

	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.openAndClose = function(id) {


		if(!$('.js-accordeon-item-inside-' + id).parent().hasClass('open')) {
			
			/*
			Close all
			*/
			$('.js-accordeon-item-inside').slideUp();
			$('.js-accordeon-item-inside').parent().removeClass('open');

			/*
			Open specific one
			*/
			$('.js-accordeon-item-inside-' + id).parent().addClass('open');
			$('.js-accordeon-item-inside-' + id).slideDown();

		} else {

			/*
			Close all
			*/
			$('.js-accordeon-item-inside').slideUp();
			$('.js-accordeon-item-inside').parent().removeClass('open');

		}

	};

		
}).apply(specific_accordeon); 